import { Box, Card, Typography } from "@mui/material";
import React from "react";

interface SuggestionsListProps {
  suggestions: string[];
}

const SuggestionsList: React.FC<SuggestionsListProps> = ({ suggestions }) => {
  return (
    <>
      {suggestions.length > 0 ? (
        <Card
          sx={{
            p: "24px",
            mb: 2,
            borderRadius: "8px",
            backgroundColor: "#FFFFFF",
            boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: "18px",
              fontWeight: "600",
              fontFamily: "Inter",
              color: "#121828",
              mb: 1,
            }}
          >
            Suggested actions
          </Typography>

          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "400",
              fontFamily: "Inter",
              color: "#6B7280",
              mb: 3,
            }}
          >
            Actionable recommendations to further boost EEAT:
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {suggestions.map((suggestion, index) => (
              <Box
                key={index}
                sx={{
                  p: "16px",
                  borderRadius: "8px",
                  backgroundColor: "#F9FAFC",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "12px",
                }}
              >
                <Box
                  sx={{
                    minWidth: "24px",
                    height: "24px",
                    borderRadius: "4px",
                    backgroundColor: "#F3F4F6",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "600",
                    fontSize: "14px",
                    color: "#374151",
                    mt: "2px",
                  }}
                >
                  {index + 1}
                </Box>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "500",
                    fontFamily: "Inter",
                    color: "#6B7280",
                    lineHeight: 1.5,
                  }}
                >
                  {suggestion}
                </Typography>
              </Box>
            ))}
          </Box>
        </Card>
      ) : (
        <Typography variant="subtitle1">
          We couldn't find any suggestions for this article.
        </Typography>
      )}
    </>
  );
};

export default SuggestionsList;
